import React from 'react';




import Header from './Header';
import Footer from './Footer';
import Feature from './Features';
import FooterBanner from './FooterBanner';


function PrimeFeatures() {
return (
<React.StrictMode>
   <Header/>
   <section id="faq" className="pb-0 pt-5 border-top">
        <div className="container mt-lg-5 ">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center">
              <h2 className="section-title mb-sm-4 mt-0">TallyPrime Features</h2>
              <p className="text-muted mb-0 mb-sm-3">At Tally innovation never stops. Our drive to simplify the lives of business owners never fades. That is why , we have gone a step further to #MakeEveryDaySimple for you

</p>
            </div>
          </div>
        </div>
      </section>
   <Feature/>
   <FooterBanner/>
    <Footer/>
</React.StrictMode>
)
}
export default PrimeFeatures;